import { Components, Theme } from '@mui/material/styles'

export const MuiListItemText: Components<Theme>['MuiListItemText'] = {
  defaultProps: {
    slotProps: {
      primary: { variant: 'cta1' },
      secondary: { variant: 'body2' },
    },
  },

  styleOverrides: {
    root: {
      margin: 0,
      minWidth: 'initial',
    },
    secondary: ({ theme }) => ({
      color: theme.palette.grey[500],
    }),
  },
}
